<button 
  class="sidebar-mobile-button button button--white"
  (click)="openSidebar()"
>
  <i class="fa-solid fa-bars sidebar-mobile-button__icon"></i>
</button>

<div class="sidebar"
    [class.sidebar--opened]="sidebarIsOpened"
>
  <div class="top">
    <div class="sidebar__logo">
      <app-logo
        [routerLink]="['/manage']"
      ></app-logo>

      <button class="button button--white"
        (click)="closeSidebar()"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="menu">
      <div class="menu-item"
        [routerLink]="['/manage/dashboard']"
        routerLinkActive="menu-item--active"
        (click)="closeSidebar()"
        >
        <div class="menu-item__label">
          <i class="fa-solid fa-gauge-high"></i>
          <p>{{'sidebar.dashboard'|transloco}}</p>
        </div>
      </div>
      <div class="menu-item"
        [routerLink]="['/manage/calendar']"
        routerLinkActive="menu-item--active"
        (click)="closeSidebar()"
        >
        <div class="menu-item__label">
          <i class="fa-solid fa-calendar-days"></i>
          <p>{{'sidebar.calendar'|transloco}}</p>
        </div>
      </div>
      <div class="menu-item"
        [routerLink]="['/manage/public-profile']"
        routerLinkActive="menu-item--active"
        (click)="closeSidebar()"
        >
        <div class="menu-item__label">
          <i class="fa-solid fa-user"></i>
          <p>{{'sidebar.public-profile'|transloco}}</p>
        </div>

        @if (onboarding && !onboarding.publicProfile) {
          <div class="menu-item__onboarding"
            >
            <div class="menu-item__onboarding-icon">
              <i class="fa-solid fa-circle-exclamation"></i>
            </div>
            <div class="menu-item__onboarding-modal">
              <p>{{ 'sidebar.public-profile.onboarding.label'|transloco }}</p>
            </div>
          </div>
        }
      </div>
      <div class="menu-item"
        [routerLink]="['/manage/services']"
        routerLinkActive="menu-item--active"
        (click)="closeSidebar()"
        >
        <div class="menu-item__label">
          <i class="fa-solid fa-box"></i>
          <p>{{'sidebar.services'|transloco}}</p>
        </div>

        @if (onboarding && !onboarding.services) {
          <div class="menu-item__onboarding"
            >
            <div class="menu-item__onboarding-icon">
              <i class="fa-solid fa-circle-exclamation"></i>
            </div>
            <div class="menu-item__onboarding-modal">
              <p>{{ 'sidebar.services.onboarding.label'|transloco }}</p>
            </div>
          </div>
        }
      </div>
      <div class="menu-item"
        [routerLink]="['/manage/bookings']"
        routerLinkActive="menu-item--active"
        (click)="closeSidebar()"
        >
        <div class="menu-item__label">
          <i class="fa-solid fa-handshake"></i>
          <p>{{'sidebar.bookings'|transloco}}</p>
        </div>
        @if (sidebarNotifications
        && sidebarNotifications.numberOfBookingsPendingApproval
        && sidebarNotifications.numberOfBookingsPendingApproval > 0) {
          <div class="menu-item__notifications">
            <p>{{sidebarNotifications.numberOfBookingsPendingApproval}}</p>
          </div>
        }
      </div>
      <div class="menu-item"
        [routerLink]="['/manage/pay']"
        routerLinkActive="menu-item--active"
        (click)="closeSidebar()"
        >
        <div class="menu-item__label">
          <i class="fa-solid fa-file-invoice-dollar"></i>
          <p>{{'sidebar.pay'|transloco}}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="bottom">
    @if (showTrial) {
      <app-sidebar-trial
        [trialEndDate]="user?.trialEndDate ?? null"
      ></app-sidebar-trial>
    }
    <div class="menu">
      <a class="menu-item"
         href="/"
           target="_blank"
      >
        <div class="menu-item__label">
          <i class="fa-solid fa-arrow-up-right-from-square"></i>
          <p>{{'sidebar.open-marketplace'|transloco}}</p>
        </div>
      </a>
    </div>
    <app-user-menu></app-user-menu>
  </div>
</div>
<div class="sidebar-mobile-background"
     [class.sidebar-mobile-background--opened]="sidebarIsOpened"
     (click)="closeSidebar()"
></div>
